import { fetchMunicipalities } from '../helpers/api'
// import ComboBox from './combobox-v2'

export default class MunicipalityFilter {
  constructor () {
    this.filter = { municipality: undefined }
    this.shown = false
    this.preventClosing = false
    this._events = []
    this.currentItem = null
    this.currentItemIndex = null
    this.visibleCount = 0
  }

  static get EVENT () {
    return {
      CHANGE: 'poin:municipalityFilter:change',
      OPEN: 'poin:municipalityFilter:open',
      CLOSE: 'poin:municipalityFilter:close'
    }
  }

  async init () {
    this._dropdown = document.getElementById('municipality-filter-dropdown')
    this._input = document.getElementById('municipality-filter-input')

    const municipalities = await fetchMunicipalities()
    municipalities.forEach((municipality, index) => {
      const option = document.createElement('option')
      option.id = `municipality-${index}`
      option.textContent = municipality
      option.classList.add('municipality')

      this._dropdown.appendChild(option)
    })

    this._itemList = this._dropdown.querySelectorAll('.municipality')
    document.querySelector('#municipality-filter .material-icons').addEventListener('click', () => {
      if (this.shown) {
        this._input.blur()
      } else {
        this._input.focus()
      }
    })
    this._input.addEventListener('focus', this.open.bind(this))
    this._input.addEventListener('blur', this.close.bind(this))
    this._input.addEventListener('input', (event) => {
      const re = new RegExp(`(${event.target.value})`, 'i')
      this.visibleCount = 0

      this._itemList.forEach((item) => {
        const match = item.textContent.match(re)

        if (match) {
          item.classList.remove('hide')
          ++this.visibleCount
        } else {
          item.classList.add('hide')
        }
      })
    })

    this._input.addEventListener('keydown', (event) => {
      if (this.shown) {
        switch (event.key) {
          case 'ArrowUp':
            if (this.visibleCount > 0) {
              if (this.visibleCount === 1) { this.currentItemIndex = this._itemList.length - 1 }

              do {
                --this.currentItemIndex
              } while (this.currentItemIndex >= 0 && this._elementIsHidden(this.currentItemIndex))

              if (this.currentItemIndex < 0) { this.currentItemIndex = this._itemList.length - 1 }
              if (this.currentItem) { this.currentItem.classList.remove('light') }

              this.currentItem = this._itemList[this.currentItemIndex]
              this.currentItem.classList.add('light')
              this.currentItem.scrollIntoView({ behaviour: 'smooth', block: 'nearest', inline: 'nearest' })
            }
            break
          case 'ArrowDown':
            if (this.visibleCount > 0) {
              do {
                if (this.currentItemIndex !== null) {
                  ++this.currentItemIndex
                } else {
                  this.currentItemIndex = 0
                }
              } while (this.currentItemIndex < this._itemList.length && this._elementIsHidden(this.currentItemIndex))

              if (this.currentItemIndex >= this._itemList.length) { this.currentItemIndex = 0 }
              if (this.currentItem) { this.currentItem.classList.remove('light') }

              this.currentItem = this._itemList[this.currentItemIndex]
              this.currentItem.classList.add('light')
              this.currentItem.scrollIntoView({ behaviour: 'smooth', block: 'nearest', inline: 'nearest' })
            }
            break
          case 'Enter':
            this.select(this.currentItem.value)
            this.handle(this.currentItem.value)
            this.forceClose()
            break
          default:

            break
        }
      } else {
        this.open()
      }
    })

    const queryParams = new URLSearchParams(window.location.search)
    const municipality = queryParams.get('municipality')

    if (municipality) {
      this.filter.municipality = municipality
      this.select(municipality)
      this.handle(municipality)
    }
  }

  /**
   * @param {string} municipality
   */
  handle (municipality) {
    if (municipality !== '') this.filter.municipality = municipality
    else this.filter.municipality = undefined

    this._input.dispatchEvent(new Event(MunicipalityFilter.EVENT.CHANGE, { bubbles: true }))
  }

  select (municipality) {
    this.preventClosing = false
    this._input.value = municipality
    this._dropdown.classList.remove('show')
  }

  clean () {
    this._input.value = ''
    this.handle(undefined)
  }

  disable () {
    this.filter.municipality = undefined
    this._input.disabled = true
    this._input.classList.add('disabled')
  }

  enable () {
    this._input.disabled = false
    this._input.classList.remove('disabled')
  }

  open () {
    this.shown = true
    this.preventClosing = false
    this._dropdown.style.left = `${this._input.offsetLeft - 20}px`
    this._dropdown.style.top = `${this._input.offsetTop + this._input.offsetHeight + 20}px`
    this._dropdown.style.width = `${this._dropdown.parentElement.clientWidth}px`
    this._dropdown.classList.add('show')
    this.visibleCount = this._itemList.length

    this._dropdown.addEventListener('mouseleave', () => { this.preventClosing = false })
    this._dropdown.addEventListener('mouseenter', () => { this.preventClosing = true })

    this._itemList.forEach((option) => {
      const boundClick = (event) => {
        this.select(event.target.value)
        this.handle(event.target.value)
        this.close()
      }
      const boundMouseOver = (event) => {
        this._itemList.forEach((item, index) => {
          if (event.target === item) {
            if (this.currentItem) {
              this.currentItem.classList.remove('light')
            }
            this.currentItem = item
            this.currentItemIndex = index
            this.currentItem.classList.add('light')
          }
        })
      }
      this._events.push({
        boundClick,
        boundMouseOver
      })

      option.addEventListener('click', boundClick)
      option.addEventListener('mouseover', boundMouseOver)
    })

    this._input.dispatchEvent(new Event(MunicipalityFilter.EVENT.OPEN, { bubbles: true }))
  }

  close () {
    if (!this.preventClosing) {
      this.forceClose()
    }
  }

  navigate () {

  }

  forceClose () {
    setTimeout(() => {
      this.shown = false
      this._dropdown.classList.remove('show')
    }, 150)

    this._itemList.forEach((option, index) => {
      option.removeEventListener('click', this._events[index]?.boundClick)
      option.removeEventListener('mouseover', this._events[index]?.boundMouseOver)
    })
    this._events = []
    this._input.dispatchEvent(new Event(MunicipalityFilter.EVENT.CLOSE, { bubbles: true }))
  }

  filterIsSet () {
    return Boolean(this.filter.municipality)
  }

  _elementIsHidden (index) {
    return this._itemList[index].classList.contains('hide')
  }
}
